/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpressOutboundOrderVo
 */
export interface ExpressOutboundOrderVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof ExpressOutboundOrderVo
     */
    orderId?: number;
    /**
     * 请求类型
     * @type {string}
     * @memberof ExpressOutboundOrderVo
     */
    requestType?: string;
    /**
     * 收货人
     * @type {string}
     * @memberof ExpressOutboundOrderVo
     */
    receiver?: string;
    /**
     * 总箱数
     * @type {number}
     * @memberof ExpressOutboundOrderVo
     */
    boxTotalCount?: number;
    /**
     * 总重量
     * @type {number}
     * @memberof ExpressOutboundOrderVo
     */
    totalWeight?: number;
    /**
     * 出库运单号
     * @type {string}
     * @memberof ExpressOutboundOrderVo
     */
    ivc?: string;
    /**
     * 订单号
     * @type {string}
     * @memberof ExpressOutboundOrderVo
     */
    orderCode?: string;
    /**
     * 国际运输方式ID
     * @type {number}
     * @memberof ExpressOutboundOrderVo
     */
    internationalTransportMethodId?: number;
    /**
     * 国际运输方式名称
     * @type {string}
     * @memberof ExpressOutboundOrderVo
     */
    internationalTransportMethodName?: string;
    /**
     * 总体积
     * @type {number}
     * @memberof ExpressOutboundOrderVo
     */
    totalCBM?: number;
}

/**
 * Check if a given object implements the ExpressOutboundOrderVo interface.
 */
export function instanceOfExpressOutboundOrderVo(value: object): value is ExpressOutboundOrderVo {
    return true;
}

export function ExpressOutboundOrderVoFromJSON(json: any): ExpressOutboundOrderVo {
    return ExpressOutboundOrderVoFromJSONTyped(json, false);
}

export function ExpressOutboundOrderVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpressOutboundOrderVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'receiver': json['receiver'] == null ? undefined : json['receiver'],
        'boxTotalCount': json['boxTotalCount'] == null ? undefined : json['boxTotalCount'],
        'totalWeight': json['totalWeight'] == null ? undefined : json['totalWeight'],
        'ivc': json['ivc'] == null ? undefined : json['ivc'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'internationalTransportMethodId': json['internationalTransportMethodId'] == null ? undefined : json['internationalTransportMethodId'],
        'internationalTransportMethodName': json['internationalTransportMethodName'] == null ? undefined : json['internationalTransportMethodName'],
        'totalCBM': json['totalCBM'] == null ? undefined : json['totalCBM'],
    };
}

export function ExpressOutboundOrderVoToJSON(json: any): ExpressOutboundOrderVo {
    return ExpressOutboundOrderVoToJSONTyped(json, false);
}

export function ExpressOutboundOrderVoToJSONTyped(value?: ExpressOutboundOrderVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'requestType': value['requestType'],
        'receiver': value['receiver'],
        'boxTotalCount': value['boxTotalCount'],
        'totalWeight': value['totalWeight'],
        'ivc': value['ivc'],
        'orderCode': value['orderCode'],
        'internationalTransportMethodId': value['internationalTransportMethodId'],
        'internationalTransportMethodName': value['internationalTransportMethodName'],
        'totalCBM': value['totalCBM'],
    };
}

